import "./App.css";
import React, { useCallback, useEffect, useState } from "react";
import YouTube from "react-youtube";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

var playlistDon = {
  url: "PLfe6aUGOlJuCoCcpuiDmg1u5XVKRUwFAs",
  count: 50,
  name: "Nice Sets",
};

function App() {
  const [currVidIndex, setCurrVidIndex] = useState(0);
  const [items, setItems] = useState([]);

  const onEnd = useCallback(async () => {
    // setCurrVidIndex(null);
    // await sleep(2000);
    setCurrVidIndex(currVidIndex + 1);
  });
  const onLoad = useCallback(async (e) => {
    console.log({ e });
  });

  useEffect(() => {
    const fetchPlaylistItems = async () => {
      let pageToken = undefined;
      let count = 1;
      var url = new URL("https://www.googleapis.com/youtube/v3/playlistItems");
      let items = [];

      while (pageToken !== null) {
        const params = {
          part: "snippet",
          maxResults: 50,
          playlistId: playlistDon.url, // selecting the random playlist
          ...(pageToken ? { pageToken } : {}),
          key: "AIzaSyB9S0x69Lz_gdnFUlKw7SfTaFY2RM34hEs",
        };
        Object.keys(params).forEach((key) =>
          url.searchParams.append(key, params[key])
        );
        const response = await fetch(url);
        const playlistItems = await response.json();
        pageToken = playlistItems.nextPageToken
          ? playlistItems.nextPageToken
          : null;
        ++count;
        items = [...items, ...playlistItems.items];
      }

      setItems(items);
    };
    fetchPlaylistItems();
  }, []);

  const playTrack = useCallback((trackIndex) => {
    setCurrVidIndex(trackIndex);
  });

  const opts = {
    // height: "auto",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const currVideId = items[currVidIndex]?.snippet.resourceId.videoId;
  console.log({ currVideId });
  console.log({ items });

  return (
    <div className="App">
      <center>
      <div id="topbar"><span style={{color:'#000000', fontSize:'72px', fontFamily:'arial,helvetica,sans-serif', fontStyle: 'italic'}}>
          NICE SETS
      </span>
      </div>
      </center>
      <div className="video-and-playlist-container">
        <div className="video-container">
          {currVideId && (
            <YouTube
              videoId={currVideId}
              opts={opts}
              onEnd={onEnd}
              onLoad={onLoad}
            />
          )}
          <div>
            <button
              onClick={() => {
                if (currVidIndex === 0) return;
                setCurrVidIndex(currVidIndex - 1);
              }}
            >
              prev{" "}
            </button>
            <button
              onClick={() => {
                setCurrVidIndex(currVidIndex + 1);
              }}
            >
              next{" "}
            </button>
            <button
              onClick={() => {
                var indexRando = Math.floor((Math.random() * items.length));
                console.log({ indexRando });
                setCurrVidIndex(indexRando);
              }}
            >
              ???{" "}
            </button>

            <iframe frameBorder="0" height="240" scrolling="yes" seamless="seamless" src="https://www.cognitoforms.com/f/i-Ko6p0feUSqtBXPe5r2bg?id=1" style={{position:'relative', width:'100%'}}></iframe>

          </div>
        </div>
        <div id="the-list">
          {items.map((x, i) => (
            <div
              onClick={() => {
                playTrack(i);
              }}
            >
              {x.snippet.title}
              <div>
                {" "}
                {Object.entries(x.snippet.thumbnails).map(([key, value]) => {
                  if (key === "default") {
                    return <img src={value.url} />;
                  }
                })}
              </div>
              <hr />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
